import React from 'react';
import {
  BuilderHeader,
  BuilderHeaderSubject,
} from '../../../../../components/Builder/BuilderHeader';
import {
  PermissionKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import SignificanceMode from './SignificanceMode';
import ThinDivider from '../../../../../components/ThinDivider';
import { useAppSelector } from '../../../../../redux/hooks';
import { activeSchemaIdSelector } from '../../../../../redux/selectors/builder';
import useShowLumosButton from '../../../../../components/LumosButton/useShowLumosButton';
import LumosButton from '../../../../../components/LumosButton';

const queryType = QueryType.Significance;

const SignificanceBuilderHeader = () => {
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const shouldShowLumosButton = useShowLumosButton(
    activeSchemaId,
    PermissionKey.AnalysisCreate,
  );

  return (
    <BuilderHeader queryType={queryType}>
      <ThinDivider layout="vertical" size="short" />
      <BuilderHeaderSubject queryType={queryType} />
      <ThinDivider layout="vertical" size="short" />
      <SignificanceMode />
      {shouldShowLumosButton && <LumosButton />}
    </BuilderHeader>
  );
};

export default SignificanceBuilderHeader;
